import { TableProps, Table as AntTable } from 'antd';
import './antStyle.scss';

const Table: React.FC<TableProps<any>> = ({ ...props }) => {
  return <AntTable {...props} />;
};
export default Table;
